import { $authHost } from ".."

export const getDepartmentTypesAllAPI = async () => {
    const {data} = await $authHost.get(`api/department_types/all`)
    return data
}